<template>
  <div>
    <div v-if="!text">
      <canvas
        id="myChart33"
        width="350"
        height="180"
      />
      <v-row
        v-if="exibirLegenda"
        align="center"
        class="ma-0"
        no-gutters
      >
        <v-col
          id="legendaId"
          md="12"
          offset-md="1"
        >
          <v-row>
            <div
              v-for="status in corLegenda"
              :key="status.status"
            >
              <v-avatar
                class="mr-1"
                :color="status.cor"
                size="12"
              />
              <span
                id="statusDevolucaoPropria"
                class="mr-3 font-weight-light"
              >{{ status.status }}</span><br>
              <div :style="{ 'font-weight': 'bold', 'font-size': '16px', 'color': status.cor }">
                {{ status.valor }}
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardCoberturaParticipantes',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleCliente: {
        color: '#ed934f',
      },
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      clientesFaturado: 0,
      clientesTotalAtivos: 0,
      porcentagemClientesFaturados: null,
      exibirLegenda: false,
      corLegenda: [
        { status: 'Positivação', valor: 0, cor: '#2863af' },
        { status: 'Sem Faturamento', valor: 0, cor: '#ed934f' },
      ],
    }),

    created () {
      eventEmit.$on('set-cobertura-participantes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-cobertura-participantes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (clientesFaturado, clientesTotalAtivos) {
        this.clientesFaturado = clientesFaturado
        this.clientesTotalAtivos = clientesTotalAtivos
        this.exibirLegenda = false

        this.MontarGrafico()
      },

      MontarGrafico () {
        const label = ['Positivação', 'Sem Positivação']

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        if (this.montaGrafico) {
          this.montaGrafico = false

          const porcentagemClientesFaturado = this.clientesTotalAtivos ? (this.clientesFaturado / this.clientesTotalAtivos) * 100 : 0
          const restantePorcentagem = porcentagemClientesFaturado ? 100 - porcentagemClientesFaturado : 0

          this.porcentagemClientesFaturados = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'

          this.corLegenda[0].valor = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'
          this.corLegenda[1].valor = restantePorcentagem.toFixed(2).toString().replace('.', ',') + '%'

          const ctx = document.getElementById('myChart33').getContext('2d')
          this.myChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Positivação', 'Sem Positivação'],
              datasets: [
                {
                  label: 'Porcentagem',
                  data: [porcentagemClientesFaturado, restantePorcentagem],
                  backgroundColor: [
                    '#2863af',
                    '#ed934f',
                  ],
                },
              ],
            },
            options: {
              legend: {
                display: false,
              },
              responsive: true,
              cutoutPercentage: 70,
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    if (tooltipItem.index === 0) {
                      return 'Total: ' + this.clientesFaturado
                    } else if (tooltipItem.index === 1) {
                      return 'Total: ' + (this.clientesTotalAtivos - this.clientesFaturado)
                    }
                  },
                  title: (tooltipItem) => {
                    return label[tooltipItem[0].index]
                  },
                },
              },
            },
          })

          this.exibirLegenda = true
        } else {
          if (this.myChart.data) {
            this.myChart.destroy()
          }

          this.porcentagemClientesFaturados = null

          const porcentagemClientesFaturado = this.clientesTotalAtivos ? (this.clientesFaturado / this.clientesTotalAtivos) * 100 : 0
          const restantePorcentagem = porcentagemClientesFaturado ? 100 - porcentagemClientesFaturado : 0

          this.porcentagemClientesFaturados = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'

          this.corLegenda[0].valor = porcentagemClientesFaturado.toFixed(2).toString().replace('.', ',') + '%'
          this.corLegenda[1].valor = restantePorcentagem.toFixed(2).toString().replace('.', ',') + '%'

          const ctx = document.getElementById('myChart33').getContext('2d')
          this.myChart = new Chart(ctx, {
            type: 'doughnut',
            data: {
              labels: ['Positivação', 'Sem Positivação'],
              datasets: [
                {
                  label: 'Faturamento',
                  data: [porcentagemClientesFaturado, restantePorcentagem],
                  backgroundColor: [
                    '#2863af',
                    '#ed934f',
                  ],
                },
              ],
            },
            options: {
              legend: {
                display: false,
              },
              responsive: true,
              cutoutPercentage: 70,
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    if (tooltipItem.index === 0) {
                      return 'Total: ' + this.clientesFaturado
                    } else if (tooltipItem.index === 1) {
                      return 'Total: ' + (this.clientesTotalAtivos - this.clientesFaturado)
                    }
                  },
                  title: (tooltipItem) => {
                    return label[tooltipItem[0].index]
                  },
                },
              },
            },
          })

          this.exibirLegenda = true
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart33 {
      margin: -1rem 0 0 19rem;
    }

    #legendaId {
      margin: 3rem 0 0 23.8rem
    }
  }

  @media screen
  and (min-width: 1380px)
  and (max-width : 1799px)
  {
    #myChart33 {
      width: 322px !important;
      height: 166px !important;
      margin: -1rem 0 0 0rem;
    }

    #legendaId {
      margin: 1rem 0 0 5.8rem
    }
  }

  @media screen
  and (min-width: 1800px) {
    #myChart33 {
      width: 408px !important;
      height: 220px !important;
      margin: -1rem 0 0 1rem;
    }

    #legendaId {
      margin: 1rem 0 0 5.8rem
    }
  }
</style>

<style lang="sass">
  #myChart33
    margin: -1.5rem 0 0 0
    width: 322px !important
    height: 166px !important

  #legendaId
    margin: 1rem 0 0 4.5rem

</style>
